import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Route, Routes, useNavigate } from 'react-router-dom';


import toast from 'react-hot-toast';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { DataContext } from '../../init/getData';

import Chart from "react-apexcharts";
import DropDownFilter from '../../components/filters/dropDownFilter';
import YearlySales from './cards/yearly';
import MonthlySales from './cards/monthly';



const SalesDashboard = (props) => {

  const { userData, settingData, devData, api, companyId, yearId, selectedYear } = useContext(DataContext);



  return (

    <div style={{ display: "flex", gap: "16px", width: "100%" }}>
      <div style={{ flex: "1" }}>
        <YearlySales />
      </div>
      <div style={{ flex: "1" }}>
        <MonthlySales />
      </div>
    </div>
  );
}


export default SalesDashboard;